import React from 'react';
import { BRAND_LIBRARY_DARK_TEXT_COLOR } from 'common/constants/brandLibrary';

import Paragraph from './PastSessionListParagraph.styles';

export default function PastSessionListParagraph(props) {
    return <Paragraph {...props} />;
}

PastSessionListParagraph.splash = {
    ...Paragraph.splash,
    defaultProps: {
        ...Paragraph.splash.defaultProps,
        styles: {
            ...Paragraph.splash.defaultProps.styles,
            fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
            fontSize: 16,
        },
        meta: {
            ...Paragraph.splash.defaultProps.meta,
            // eslint-disable-next-line max-len
            content: 'Recordings for each session will be distributed after the event',
        },
    },
};
